/* eslint-disable max-lines */
import * as router_helpers from "@/router";
import Swal from "sweetalert2";
import event_helpers from "./view_event_helpers";
import * as event_realtime_helpers from "@/services/eventRealtimeHandlers";

const view_event_component_methods = {
    get_creator_survey_response_count(survey) {
      const questions = Array.isArray(survey?.survey_questions) ? survey.survey_questions : [];
      const ids = new Set();
      questions.forEach((item) => {
        const answers = Array.isArray(item?.answers) ? item.answers : [];
        answers.forEach((answer) => {
          const userId = answer?.user?.id;
          if (userId !== undefined && userId !== null) {
            ids.add(String(userId));
          }
        });
      });
      return ids.size;
    },
    get_creator_survey_question_response_count(question) {
      return Array.isArray(question?.answers) ? question.answers.length : 0;
    },
    handle_realtime_event(event) {
      event_realtime_helpers.handle_manage_event_realtime(this, event);
    },
    get_auth_token() {
      return router_helpers.get_token();
    },
    // We need a local get_token for the helper functions that use this.get_token()
    get_token() {
      return router_helpers.get_token();
    },
    get_user_id() {
      return event_helpers.get_user_id();
    },
    format_date(dateString) {
      return event_helpers.format_date(dateString);
    },
    form_time(timeString) {
      return event_helpers.format_time(timeString);
    },
    check_description(description) {
      return event_helpers.check_description(description);
    },
    truncate_description(description, maxLength = 25) {
      return event_helpers.truncate_description(description, maxLength);
    },
    is_promo_valid(startDateStr, endDateStr) {
      return event_helpers.is_promo_valid(startDateStr, endDateStr);
    },
    open_promo_code_modal() {
      $("#availablePromosModal").modal("show");
    },
    has_agenda(event) {
      if (event?.agenda?.length) return true;
      return (event?.event_files || []).some((file) => {
        const name = String(file?.event_file_type?.name || "").toLowerCase();
        return name === "agenda" || name.includes("agenda");
      });
    },
    view_agenda(event) {
      this.$refs.eventAgendaRef?.open_view_agenda?.(event);
    },
    select_promo(promo) {
      event_helpers.select_promo(promo, () => {
        this.show_toast("Promo Code copied to clipboard!");
      });
    },
    show_toast(message) {
      event_helpers.show_toast(message);
    },
    toggle_description() {
      this.show_full_description = !this.show_full_description;
    },
    toggle_item(item_id) {
      this.selected_item_id = event_helpers.toggle_item(this.selected_item_id, item_id);
    },
    select_ticket(ticket) {
      const selectedTicketId = event_helpers.select_ticket(ticket);
      if (selectedTicketId === null || selectedTicketId === undefined) return;
      this.selected_ticket_id = selectedTicketId;
    },
    increment_ticket(ticket) {
      const nextQuantity = event_helpers.increment_ticket(ticket);
      if (nextQuantity === null) return;
      ticket.quantitySelected = nextQuantity;
    },
    decrement_ticket(ticket) {
      const nextQuantity = event_helpers.decrement_ticket(ticket);
      if (nextQuantity === null) return;
      ticket.quantitySelected = nextQuantity;
    },
    validate_ticket_date(ticket_start_date) {
      return event_helpers.validate_ticket_date(ticket_start_date);
    },
    calculate_subtotal() {
      return event_helpers.calculate_subtotal(this.event_tickets);
    },
    calculate_total() {
      return event_helpers.calculate_total(this.event_tickets, this.applied_promo);
    },
    add_rsvp() {
      event_helpers.add_rsvp(this);
    },
    open_rsvp_modal(event) {
      if (!this.token_exists) {
        const nextUrl = this.$router?.currentRoute?.value?.fullPath;
        if (nextUrl) sessionStorage.setItem("next", nextUrl);
        window.location = "/login";
        return;
      }
      if (!event) return;

      this.selected_event = event;
      if (event.is_free) {
        $("#eventModal").modal("show");
        return;
      }
      this.handle_rsvp(event);
    },
    handle_rsvp(event) {
      if (!this.token_exists) {
        window.location = '/login';
        return;
      }
      if (!event) return;
      this.selected_event = event;

      const rsvpPeriod = this.get_rsvp_period_status(event);
      if (rsvpPeriod.reason === "not_started") {
        this.show_rsvp_open_soon(rsvpPeriod.openingText);
        return;
      }

      if (event.is_free) {
        this.fetchEvents_extras(event.id);
      } else {
        this.reset_promo();
        const tickets = Array.isArray(event.event_tickets) ? event.event_tickets : [];
        this.event_tickets = tickets.map((ticket) => ({
          ...ticket,
          quantitySelected: 0,
        }));
        $("#ticket_modal").modal("show");
      }
    },
    get_rsvp_period_status(event) {
      const start = new Date(`${event?.rsvp_start_date}T${event?.rsvp_start_time}`);
      const end = new Date(`${event?.rsvp_end_date}T${event?.rsvp_end_time}`);
      const now = new Date();
      if (Number.isNaN(start.getTime())) {
        return ({ isValid: true, reason: "open", message: "", openingText: "" });
      }
      if (now < start) {
        const openingDate = start.toLocaleDateString("en-GB", {
          weekday: "long",
          day: "2-digit",
          month: "long",
        });
        const openingTime = start.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        return ({
          isValid: false,
          reason: "not_started",
          message: "RSVP has not started yet.",
          openingText: `${openingDate} at ${openingTime}`,
        });
      }
      if (!Number.isNaN(end.getTime()) && now > end) {
        const closingDate = end.toLocaleDateString("en-GB", {
          weekday: "long",
          day: "2-digit",
          month: "long",
        });
        const closingTime = end.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        return ({
          isValid: false,
          reason: "ended",
          message: "RSVP period has ended.",
          openingText: "",
          closingText: `${closingDate} at ${closingTime}`,
        });
      }
      return ({
        isValid: true,
        reason: "open",
        message: "",
        openingText: "",
        closingText: "",
      });
    },
    show_rsvp_open_soon(openingText) {
      this.rsvp_opening_text = openingText;
      $("#rsvp_open_soon_modal").modal("show");
    },
    get_event_join_status(event) {
      const start = new Date(`${event?.start_date}T${event?.start_time}`);
      const end = new Date(`${event?.end_date}T${event?.end_time}`);
      const now = new Date();
      if (!Number.isNaN(start.getTime()) && now < start) {
        return ({ canJoin: false, message: "The event hasn't started yet." });
      }
      if (!Number.isNaN(end.getTime()) && now > end) {
        return ({ canJoin: false, message: "The event has ended." });
      }
      return ({ canJoin: true, message: "" });
    },
    rsvp_button(event) {
      return this.can_show_rsvp_button(event);
    },
    can_show_rsvp_button(event) {
      if (!event?.is_free) return false;
      // Use the same derived capacity/registration numbers as the "spots left" UI,
      // so realtime updates don't leave the button in a stale state.
      const capacity = event_helpers.capacity_value(event);
      if (!capacity) return true;
      const total = event_helpers.total_registrations(event);
      return total < capacity;
    },
    get_selected_checkout_tickets() {
      return this.event_tickets
        .filter((ticket) => ticket.quantitySelected > 0)
        .map((ticket) => ({
          ticket_id: ticket.id,
          quantity: ticket.quantitySelected,
        }));
    },
    show_no_checkout_tickets_message() {
      Swal.fire({
        title: "No tickets selected",
        text: "Please choose at least one ticket.",
        icon: "warning",
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        toast: true,
      });
    },
    build_checkout_request_data(selectedTickets) {
      return ({
        event_id: this.selected_event.id,
        tickets: selectedTickets,
        event_promo_code_id: this.applied_promo?.id || null,
      });
    },
    handle_checkout_order_created(response) {
      if (response.status !== "success") return;
      $("#ticket_modal").modal("hide");
      $(".modal-backdrop").remove();
      this.$router.push({
        name: "checkout",
        params: { order_id: response.data.id },
      });
    },
    show_checkout_error() {
      Swal.fire({
        title: "Error",
        text: "Failed to create order.",
        icon: "error",
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        toast: true,
      });
    },
    process_to_checkout() {
      if (!this.token_exists) {
        window.location = "/login";
        return;
      }
      const selectedTickets = this.get_selected_checkout_tickets();
      if (selectedTickets.length === 0) {
        this.show_no_checkout_tickets_message();
        return;
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/ticket_purchase_api/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.get_auth_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(this.build_checkout_request_data(selectedTickets)),
        success: (response) => this.handle_checkout_order_created(response),
        error: () => this.show_checkout_error(),
      });
    },
    fetchEvents_extras(event_id) {
      return event_helpers.fetchEvents_extras(this, event_id);
    },
    reset_promo() {
      this.promo_input = "";
      this.promo_message = "";
      this.promo_status = "";
      this.applied_promo = null;
    },
    apply_promo() {
      return event_helpers.apply_promo(this);
    },
    start_scanning(eventId) {
      event_helpers.start_scanning(this, eventId);
    },
    start_camera() {
      event_helpers.start_camera(this);
    },
    scan_loop(video, canvas, context) {
      event_helpers.scan_loop(this, video, canvas, context);
    },
    stop_scanning() {
      event_helpers.stop_scanning(this);
    },
    stop_camera_only() {
      event_helpers.stop_camera_only(this);
    },
    restart_scan() {
      event_helpers.restart_scan(this);
    },
    validate_ticket(scannedCode) {
      event_helpers.validate_ticket(this, scannedCode);
    },
    validate_rsvp(scannedCode) {
      event_helpers.validate_rsvp(this, scannedCode);
    },
    submit_registration() {
      event_helpers.submit_registration(this);
    },
    export_to_csv(event) {
      event_helpers.export_to_csv(event, this.cbo_domain);
    },
    cancel_rsvp(event_id, user_id = null) {
      event_helpers.cancel_rsvp(this, event_id, user_id);
    },
    view_ticket_attendees(event) {
      event_helpers.view_ticket_attendees(this, event);
    },
    new_format_date(dateString) {
      return event_helpers.new_format_date(dateString);
    },
    get_event_media_files(event) {
      return event_helpers.get_event_media_files(event);
    },
    get_event_media_type(item) {
      return event_helpers.get_event_media_type(item);
    },
    get_event_resource_files(event) {
      return event_helpers.get_event_resource_files(event);
    },
    open_media_gallery(event) {
      if (!this.gallery_access_allowed) {
        this.show_toast("Only attendees can view this gallery.");
        return;
      }
      event_helpers.open_media_gallery(this, event);
    },
    open_document_upload(event) {
      if (!this.materials_access_allowed) {
        this.show_toast("Only attendees can view these materials.");
        return;
      }
      event_helpers.open_document_upload(this, event);
    },
    get_icon_class(item) {
      return event_helpers.get_icon_class(this, item);
    },
    get_file_type_label(item) {
      return event_helpers.get_file_type_label(this, item);
    },
    get_file_name(item) {
      return event_helpers.get_file_name(this, item);
    },
    open_preview(item) {
      event_helpers.open_preview(this, item);
    },
    download_document(item) {
      event_helpers.download_document(this, item);
    },
    update_parent_event_files(newFiles) {
      event_helpers.update_parent_event_files(this, newFiles);
    },
    handle_parent_file_deletion(deletedFileId) {
      event_helpers.handle_parent_file_deletion(this, deletedFileId);
    },
    handle_pin_update(payload) {
      event_helpers.handle_pin_update(this, payload);
    },
    get_speaker_initials(speaker) {
      return event_helpers.get_speaker_initials(speaker);
    },
    get_sponsor_initials(sponsor) {
      return event_helpers.get_sponsor_initials(sponsor);
    },
    get_sponsor_logo(sponsor) {
      return event_helpers.get_sponsor_logo(sponsor);
    },
    scroll_sponsors(direction) {
      event_helpers.scroll_sponsors(this, direction);
    },
    update_sponsor_scroll_controls() {
      event_helpers.update_sponsor_scroll_controls(this);
    },
    format_sponsor_url(url) {
      return event_helpers.format_sponsor_url(url);
    },
    open_event_speakers(event) {
      if (!event) return;
      this.$refs.eventSpeakerRef?.open_view_speakers(event);
    },
    open_add_speakers(event) {
      if (!event) return;
      this.$refs.eventSpeakerRef?.open_add_speakers(event);
    },
    open_add_sponsors(event) {
      if (!event) return;
      this.$refs.eventSponsorRef?.open_add_sponsors(event);
    },
    open_view_sponsors(event) {
      if (!event) return;
      this.$refs.eventSponsorRef?.open_view_sponsors(event);
    },
    open_promo_code_manager(event) {
      if (!event) return;
      this.$refs.promoCodeRef?.open_promo_code_manager_modal?.(event);
    },
    open_agenda_create(event) {
      if (!event) return;
      this.$refs.eventAgendaRef?.open_create_agenda?.(event);
    },
    open_create_survey(event){
      if (!event) return;
      this.$refs?.eventSurveyRef?.open_create_survey(event);
    },
    open_view_survey(survey) {
      this.$refs?.eventSurveyRef?.open_view_survey(survey);
    },
    open_edit_survey(survey){
      this.$refs?.eventSurveyRef?.open_edit_survey(survey);
    },
    delete_survey(survey_id){
     this.$refs?.eventSurveyRef?.delete_survey(survey_id);
   },
    fetch_event() {
      event_helpers.fetch_event(this);
    },
    view_attendees() {
      event_helpers.view_attendees(this);
    },
    back() {
      this.$router.back();
    },
    toggle_event_survey_checkbox_answer(question_id, option, isChecked) {
      if (!this.event_survey_answers || typeof this.event_survey_answers !== "object") {
        this.event_survey_answers = {};
      }

      const q_id = String(question_id);
      let current_answers = Reflect.get(this.event_survey_answers, q_id);
      if (!Array.isArray(current_answers)) {
        current_answers = [];
      }

      let updated_answers = [...current_answers];
      if (isChecked) {
        if (!updated_answers.includes(option)) {
          updated_answers.push(option);
        }
      } else {
        updated_answers = updated_answers.filter((answer) => answer !== option);
      }

      Reflect.set(this.event_survey_answers, q_id, updated_answers);
      if (updated_answers.length > 0) {
        this.clear_event_survey_error(question_id);
      }
    },
    validate_event_survey_number(question_id) {
      const value = Reflect.get(this.event_survey_answers, question_id);
      if (value === "" || value === null || value === undefined) {
        Reflect.set(this.event_survey_number_errors, question_id, null);
        return;
      }
      if (Number.isNaN(Number(value))) {
        Reflect.set(this.event_survey_number_errors, question_id, "Please enter a valid number.");
      } else {
        Reflect.set(this.event_survey_number_errors, question_id, null);
        this.clear_event_survey_error(question_id);
      }
    }
};

export default view_event_component_methods;
